<template>
  <div class="container">
    <div class="label">
      <h2 class="title">Forskjellige e:Ny1-farger</h2>
      <p class="variant">{{currentLabel}}</p>
    </div>
    <div class="image">
      <div class="wrapper">
        <Transition mode="in-out">
          <img :src="getCurrentImage()" :key="activeIndex">
        </Transition>
      </div>
    </div>
    <div class="colors">
      <button v-for="item, index in items" :key="item" :class="{active: isActive(index)}" @click="setActive(index)" @mouseover="setLabel(index)" @mouseleave="unsetLabel()">
        <img :src="getColorThumb(item[1])">
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ExpanderColorSlector',
    emits: ['track'],
    data() {
      return {
        activeIndex: 0,
        currentLabel: 'Arctic White',
        items: [
          [
            'Platinum White Pearl',
            'platinum',
            'platinum-white-pearl',
          ],
          [
            'Urban Grey Pearl',
            'urban',
            'urban-grey-pearl',
          ],
          [
            'Vermillion Red Pearl',
            'vermillion',
            'vermillion-red-pearl',
          ],
          [
            'Crystal Black Pearl',
            'crystal',
            'crystal-black-pearl',
          ],
          [
            'Aqua Topaz Metallic',
            'aqua',
            'aqua-topaz-metallic',
          ],
        ]
      }
    },
    methods: {
      setActive(index) {
        this.activeIndex = index
        this.$emit('track', 'color-' + this.items[this.activeIndex][2])
      },
      isActive(index) {
        return this.activeIndex === index
      },
      getColorThumb(image) {
        return require(`@/assets/colors/${image}.svg`)
      },
      getCurrentImage() {
        return require(`@/assets/models/${this.items[this.activeIndex][1]}.jpg`)
      },
      setLabel(index) {
        this.currentLabel = this.items[index][0]
      },
      unsetLabel() {
        this.currentLabel = this.items[this.activeIndex][0]
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '@/scss/mixins.scss';

  .container {
    position: relative;
    @include d {
      width: 85%;
      margin: 0 auto;
    }
  }

  .image {
    .wrapper {
      position: relative;
      aspect-ratio: 1.25;
      overflow: hidden;
      @include d {
      aspect-ratio: 2;
      }
      img {
        @include cover;
        object-fit: cover;
        object-position: center top;
      }
    }
  }

  .colors {
    position: absolute;
    left: 0;
    bottom: 1rem;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    @include d {
      bottom: 1rem;
    }
    button {
      display: block;
      width: 2rem;
      margin: 0 .5rem;
      border-radius: 50%;
      overflow: hidden;
      transition: .15s;
      @include d {
        width: 2.625rem;
      }
      &:hover {
          transform: scale(1.19);
      }
      &.active {
        transform: scale(1.19);
      }
      img {
        display: block;
        width: 100%;
        max-width: none;
      }
    }
  }

  .label {
    position: absolute;
    top: 0;
    left: 0;
    padding: 1rem 1.5rem;
    color: #fff;
    z-index: 10;
    background: radial-gradient(ellipse at center, rgba(0,0,0,.3) 0%, rgba(0,0,0,0) 50%); 
    @include d {
      padding: 1.25rem 2.25rem;
    }
    .title {
      margin-bottom: .375rem;
      font-size: 1.5rem;
      font-weight: 500;
      @include d {
        font-size: 2rem;
      }
    }
    .variant {
      font-size: 1.25rem;
      @include d {
        font-size: 1.5rem;
      }
    }
  }

  .v-enter-active,
  .v-leave-active {
    transition: opacity .4s ease;
  }

  .v-enter-from,
  .v-leave-to {
    opacity: 0;
  }

</style>
